import { html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { PortalStyle } from './katapult-model-editor-style.js';
import { DEFAULT_SCHEMAS } from '../../modules/KLogicSchemas.js';
import '../katapult-elements/katapult-button.js';
import '../k-logic-editor/k-logic-editor.js';

class KatapultVirtualRideoutEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      ${super.style} ${PortalStyle}
      <style>
        paper-cell[icon],
        paper-cell[icon-button] {
          height: 50px;
        }
        .nameCell {
          max-width: 400px;
          --paper-input-container: {
            padding: 0;
          };
        }
      </style>
      <div style="display: flex; align-items: center; gap: 20px; margin-bottom:40px;">
        <div>
          <span>Default Pole Filter:</span>
          <iron-icon style="margin-left:10px;" icon="help">
            <katapult-tooltip style="max-width:300px;" position="right">
              <div>Custom logic that returns a list of poles to include in the virtual rideout.</div>
            </katapult-tooltip>
          </iron-icon>
        </div>
        <k-logic-editor block="{{_itemData.default_pole_filter}}" schema="[[schema]]"></k-logic-editor>
      </div>
      <paper-table rounded outline slot="body" grow overflow-hidden>
        <paper-table-scroll data-path="_itemData.additional_pole_layers" on-sort-changed="orderedItemsArraySortChanged">
          <!-- Header -->
          <paper-row grey short slot="before">
            <paper-cell icon>
              <material-icon icon="swap_vert"></material-icon>
            </paper-cell>
            <paper-cell class="nameCell">
              <span>Additional Pole Layers</span>
              <iron-icon style="margin-left:10px;" icon="help">
                <katapult-tooltip style="max-width:300px;" position="right">
                  <div>
                    Custom logic that returns a list of additional poles that can be selected and included in the virtual rideout view.
                  </div>
                </katapult-tooltip>
              </iron-icon>
            </paper-cell>
            <paper-cell></paper-cell>
            <paper-cell icon-button></paper-cell>
          </paper-row>
          <!-- Body -->
          <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.additional_pole_layers.*, $true)]]">
            <paper-row slot="sortable" divider style="height:auto; align-items:start;">
              <paper-cell icon drag-handle>[[add(index, 1)]]</paper-cell>
              <paper-cell class="nameCell">
                <paper-input
                  label="Layer Name"
                  no-label-float
                  value="[[item.name]]"
                  data-path="_itemData.additional_pole_layers.$(model.item.$key).name"
                  on-value-changed="updateProperty"
                ></paper-input>
              </paper-cell>
              <paper-cell>
                <k-logic-editor
                  block="[[item.value]]"
                  schema="[[schema]]"
                  data-path="_itemData.additional_pole_layers.$(model.item.$key).value"
                  on-block-changed="updateProperty"
                ></k-logic-editor>
              </paper-cell>
              <paper-cell icon-button>
                <katapult-button
                  iconOnly
                  noBorder
                  icon="delete"
                  data-path="_itemData.additional_pole_layers.$(model.item.$key)"
                  data-value="$null"
                  on-click="updateProperty"
                ></katapult-button>
              </paper-cell>
            </paper-row>
          </template>
          <paper-row
            class="addButton"
            ripple
            light-grey
            short
            slot="after"
            data-path="_itemData.additional_pole_layers"
            on-click="addOrderedItem"
          >
            <paper-cell>
              <material-icon icon="playlist_add"></material-icon>
              <div>Add</div>
            </paper-cell>
          </paper-row>
        </paper-table-scroll>
      </paper-table>
      ${super.createItemContainer}
    `;
  }
  ready() {
    super.ready();
    this.schema = { node: DEFAULT_SCHEMAS.NODE };
  }
}

customElements.define('katapult-virtual-rideout-editor', KatapultVirtualRideoutEditor);
